import LegalShell from "./LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" lastUpdated="February 2026">
      <p>
        These Terms of Service ("Terms") govern your access to and use of the Fitest platform operated by{" "}
        <strong>Leadsopedia Limited</strong>, trading as Fitest (Company No. 13145058), 5 Brayford Square, London,
        E1 0SG. By accessing or using our platform, you agree to be bound by these Terms.
      </p>

      <h2>1. Definitions</h2>
      <p><strong>"Platform"</strong> means the Fitest website, audit and dashboard products. <strong>"Licence Holder"</strong> means a gym or business that has purchased a Gym Licence or Business Licence. <strong>"Respondent"</strong> means an end user completing a Fitest audit.</p>

      <h2>2. Eligibility</h2>
      <p>You must be at least 18 years old, or the legal age of majority in your jurisdiction, to use Fitest. By using the Platform, you represent that you meet this requirement.</p>

      <h2>3. Licences & Payments</h2>
      <p>Licences are billed via Stripe under the terms displayed at the point of purchase. Licences renew automatically unless cancelled. Refunds are handled in line with applicable UK consumer law and our internal policy.</p>

      <h2>4. Acceptable Use</h2>
      <ul>
        <li>You may not misuse the Platform or attempt to interfere with its operation.</li>
        <li>You may not use Fitest data to contact respondents who did not opt in.</li>
        <li>You may not reverse engineer, scrape, or resell access to the Platform.</li>
      </ul>

      <h2>5. Licence Holder Obligations</h2>
      <p>Licence Holders are responsible for:</p>
      <ul>
        <li>Ensuring lawful distribution of their unique audit links.</li>
        <li>Treating respondent data confidentially.</li>
        <li>Only contacting respondents who have explicitly opted in.</li>
      </ul>

      <h2>6. Intellectual Property</h2>
      <p>All content, code, scoring methodology, and branding on the Platform are owned by or licensed to Leadsopedia Limited. You may not copy, modify, or distribute any part of the Platform without our prior written consent.</p>

      <h2>7. Disclaimers</h2>
      <p>The Platform is provided on an "as is" basis. The Fitest audit is for informational and educational purposes only and is not a substitute for professional medical advice, diagnosis, or treatment. Please refer to our Medical Disclaimer.</p>

      <h2>8. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Leadsopedia Limited shall not be liable for any indirect, incidental,
        consequential, special, or punitive damages, or any loss of profits, revenue, or data, arising out of or in
        connection with your use of the Platform. Nothing in these Terms limits liability for death or personal injury
        caused by negligence, fraud, or any other liability that cannot be excluded under English law.
      </p>

      <h2>9. Termination</h2>
      <p>We may suspend or terminate your access to the Platform if you breach these Terms. You may cancel your Licence at any time via your dashboard or by contacting us.</p>

      <h2>10. Governing Law</h2>
      <p>These Terms are governed by the laws of England and Wales. Disputes shall be subject to the exclusive jurisdiction of the English courts.</p>

      <h2>11. Contact</h2>
      <p>Questions about these Terms? Contact us at <a href="mailto:hello@fitest.co.uk">hello@fitest.co.uk</a>.</p>
    </LegalShell>
  );
}
